import { ctaProductImages } from '@/mocks/articleContent';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
          Ready to Upgrade Your Shopping?
        </h2>
        <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
          Join thousands of savvy shoppers who use the Kakobuy Spreadsheet to discover the best products at the best prices every day.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2.5 mt-8 px-8 py-4 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          Buy It Now
          <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>

      <div className="mt-16 w-full overflow-hidden">
        <div className="flex gap-6 animate-scroll">
          {ctaProductImages.map((img, i) => (
            <div key={i} className="flex-shrink-0 w-40 h-40 rounded-2xl bg-background-100 overflow-hidden">
              <img
                src={img}
                alt="Kakobuy product find"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
          {ctaProductImages.map((img, i) => (
            <div key={`dup-${i}`} className="flex-shrink-0 w-40 h-40 rounded-2xl bg-background-100 overflow-hidden">
              <img
                src={img}
                alt="Kakobuy product find"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
          width: max-content;
        }
      `}</style>
    </section>
  );
}